module.exports = "pegasus/assets/background-patterns/small-crackle-bright.png";